<nav class="breadcrumb-container d-none d-sm-block d-lg-inline-block" aria-label="breadcrumb">
    <ol class="breadcrumb pt-0 pb-0">
        <li class="breadcrumb-item">
            <a>{{caption | translate}}</a>
        </li>
        <!-- <li class="breadcrumb-item active" aria-current="page">{{ title || (getLabel('/'+path) | translate) }}</li> -->
    </ol>
</nav>